import React from 'react';
import { Text } from '@chakra-ui/react';

// item 1447 (Chad: "the name should ride underneath each column or something. I'm tired of the
// name cutting off or going to a second line") — the one-line grammar for LedgerTable.rowSubline:
// the document/job NAME leads, then muted " · customer · project" meta. Spans the whole row, so it
// is never truncated and never wraps inside a squeezed cell.
interface Props {
  name?: string | null;
  meta?: (string | null | undefined)[];
}

const LedgerSubline: React.FC<Props> = ({ name, meta }) => {
  const bits = (meta ?? []).filter((m): m is string => !!m && m.trim() !== '');
  if (!name && bits.length === 0) return null;
  return (
    <Text as="div" lineHeight="short">
      {name && <Text as="span" fontWeight="medium">{name}</Text>}
      {bits.length > 0 && (
        <Text as="span" opacity={0.55}>{`${name ? ' · ' : ''}${bits.join(' · ')}`}</Text>
      )}
    </Text>
  );
};

LedgerSubline.defaultProps = { name: undefined, meta: undefined };

export default LedgerSubline;
